/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/54135086
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import * as HabitCard from '@components/LibraryToDoHabit';
import * as HabitScheduleCard from '@components/LibraryToDoHabitSchedule';
import * as QuotaCard from '@components/LibraryToDoQuota';
import * as Scorecard from '@components/LibraryToDoScoreCard';
import { AppActions, DevelopActions } from '~/actions';
import withNavigate from '~/hocs/withNavigate';

class ToDoAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = { type: props.match?.params?.activeTab };
    }

    render() {
        const { companyId, authors, departments, categories, competencies, modalData } = this.props;
        const { type } = this.state;

        return (
            <ErrorBoundary>
                {type == 'habits' && (
                    <HabitCard.Add
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        onCreate={(e) => this.props.saveTemplate(e)}
                    />
                )}
                {type == 'habitslist' && (
                    <HabitScheduleCard.Add
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        onCreate={(e) => this.props.saveTemplate(e)}
                        onModal={(e) => this.props.toggleModal(e)}
                    />
                )}
                {type == 'quotas' && (
                    <QuotaCard.Add
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        onCreate={(e) => this.props.saveTemplate(e)}
                    />
                )}
                {type == 'scorecards' && (
                    <Scorecard.Add
                        authors={authors}
                        departments={departments}
                        competencies={competencies}
                        categories={categories}
                        companyId={companyId}
                        modalData={modalData}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        onModal={(e) => this.props.toggleModal(e)}
                        onCreate={(e) => this.props.saveTemplate(e)}
                    />
                )}
            </ErrorBoundary>
        );
    }
}

ToDoAdd.propTypes = {
    templates: PropTypes.any,
    companyId: PropTypes.number,
    authors: PropTypes.array,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    categories: PropTypes.array,
    toggleModal: PropTypes.func,
    saveTemplate: PropTypes.func,
};

ToDoAdd.defaultProps = {
    companyId: 0,
    authors: [],
    departments: [],
    competencies: [],
    categories: [],
    templates: {},
    saveTemplate: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    companyId: state.app.company_info.id,
    authors: state.app.authors,
    departments: state.app.departments,
    competencies: state.app.competencies,
    templates: state.develop.templates,
    categories: state.app.categories,
    modalData: state.app.modalData,
});

const mapDispatchToProps = (dispatch) => ({
    saveTemplate: (e) => dispatch(DevelopActions.librarysaveRequest(e)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const ToDoAddWithNavigate = withNavigate(ToDoAdd);

export default connect(mapStateToProps, mapDispatchToProps)(ToDoAddWithNavigate);
